/**
 * 获取base64位的图片
 * @param fileName {String} 文件名称
 * @param caseId {String} 赔案号
 * @returns {Promise<string>}
 */
import store from '../vuex'
import api from "../ajax/api"
import axios from "axios"
export async function getImgURLOfBase64(imgUrl,fileName, caseId) {
  // 这里获取图片的地址，如果知道地址，直接绕过这部
  const res = await getImgUrl({imgUrl})
   /*const res = imgUrl;*/
   console.log(res)
  if (!res.data || res.data.length === 0) return '';
  debugger
  // 通过图片地址获取图片，从新获取图片
  var config = {
    method: 'get',
    responseType: 'arraybuffer',
    url: imgUrl,
    headers: {
      // postman 中的请求头
      source_menu_key:localStorage.getItem('menu_key')?localStorage.getItem('menu_key'):'',
      accountId:store.state.accountId,
      'Authorization' :`Bearer ${store.state.token}`, //携带权限参数
      withCredentials: true
    }
  };
  debugger
  // 重新获取请求，获取的是base64位的图片
  return await axios(config).then(response => {
    return 'data:image/png;base64,' + btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
  })
}



// WEBPACK FOOTER //
// ./src/publicMethods/axiosImage.js